import { FormControl, FormDescription, FormItem, FormLabel, FormMessage } from '.';
import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@utils/cn';
import { FormTooltip } from './tooltip';

export const FormItemWrapper = ({
  label = '',
  tooltip = '',
  msg = '',
  children,
  select = false,
  description = false,
  horizontal = false,
  className = '',
  state,
  required,
  props,
}: {
  label?: ReactNode;
  tooltip?: ReactNode;
  msg?: string;
  children: React.ReactNode;
  select?: boolean;
  description?: boolean;
  horizontal?: boolean;
  className?: string;
  state?: 'read-only' | 'disabled';
  required?: boolean;
  props?: HTMLAttributes<HTMLDivElement>;
}) => {
  // in horizontal mode the label sits next to the control, so it must not shrink or wrap
  const labelClassName = horizontal ? 'shrink-0 whitespace-nowrap' : '[&+*]:!mt-1';

  const labelNode = (
    <>
      {description && label && (
        <FormDescription className={labelClassName}>
          {label}
          {required ? '*' : null}
        </FormDescription>
      )}
      {!description && label && (
        <div className={cn('flex items-center gap-1', labelClassName)}>
          <FormLabel>
            {label}
            {required ? '*' : null}
          </FormLabel>
          {tooltip && <FormTooltip>{tooltip}</FormTooltip>}
        </div>
      )}
    </>
  );

  const controlNode = select ? (
    <>{children}</>
  ) : (
    <FormControl className={cn(!!label && 'w-full')}>{children}</FormControl>
  );

  return (
    <FormItem
      {...props}
      className={`w-full ${className} ${
        state ? (state === 'disabled' ? 'field-disabled' : 'field-read-only') : ''
      }`}>
      {horizontal ? (
        <div className="flex w-full items-center gap-2">
          {labelNode}
          {controlNode}
        </div>
      ) : (
        <>
          {labelNode}
          {controlNode}
        </>
      )}
      <FormMessage>{msg}</FormMessage>
    </FormItem>
  );
};
